/**
 * API client layer for newsletter subscriptions.
 * @module shared/api/newsletter
 */
import { apiClient } from './client';

/**
 * Subscribes a new email address to newsletter updates.
 * @param {string} email - Work email address.
 * @returns {Promise<Object>} Created subscriber record.
 */
export async function subscribeNewsletter(email, turnstileToken) {
  const res = await apiClient.post('/api/v1/newsletter/subscribe', { email, turnstile_token: turnstileToken });
  return res.data;
}

/**
 * Confirms a newsletter subscription using a verification token.
 * @param {string} token - Verification token.
 * @returns {Promise<Object>} Confirmed subscriber record.
 */
export async function confirmNewsletter(token) {
  const res = await apiClient.post('/api/v1/newsletter/confirm', { token });
  return res.data;
}

